// only run on specific page
if ( jQuery( '.pewc-product-extra-groups-wrap' ).length ) {
	// display the original pricing for the product after loading the page the first time. Wait for the caculation to complete.
	jQuery( document ).ready( function() {
		setTimeout( function() {
			jQuery( '.pewc-total-field-wrapper .woocommerce-Price-amount:eq(2)' ).addClass( 'showReworkedPricing' );
		}, 1000 );
	} );

	// work out the new pricing as it should be after checking the CSV file when the +- is clicked. Wait a split second to allow the
	// plugin to update first.
	jQuery( '.quantity .button' ).on( 'click', ( function( ) {
		setTimeout( function() {
			calculatePricing();
		}, 300 );
	} ) );

	jQuery( '.quantity input' ).on( 'change', ( function( ) {
		setTimeout( function() {
			calculatePricing();
		}, 300 );
	} ) );

	// work out the new pricing as it should be after checking the CSV file when new measurements are entered
	jQuery( 'input.pewc-form-field' ).on( 'blur', ( function( ) {
		calculatePricing();
	} ) );

	// work out the new pricing as it should be after checking the CSV file when new measurements are entered
	jQuery( 'select.pewc-form-field' ).on( 'change', ( function( ) {
		calculatePricing();
	} ) );
}

// setup the REST API call to get the new price from WooCommerce
const EqB2B = {
	restURL() {
		const pewcTotalCalcPrice = jQuery( '#pewc_total_calc_price' ).val();
		const pewcProductId = jQuery( '#pewc_product_id' ).val();
		const restUrl = jQuery( window.location ).attr( 'protocol' ) + '//' + jQuery( window.location ).attr( 'host' ) + '/wp-json/pew-global-price-range-addon/v1/product/price/convert/?price=' + pewcTotalCalcPrice + '&product_id=' + pewcProductId;

		return restUrl;
	},
};

const B2BCartAPI = {
	get( endpoint ) {
		return window.fetch( endpoint, {
			method: 'GET',
			headers: { Accept: 'application/json' },
		} )
			.then( this._handleError )
			.then( this._handleContentType )
			.catch( this._throwError );
	},
	_handleError( err ) {
		return err.ok ? err : Promise.reject( err.statusText );
	},
	_handleContentType( res ) {
		const contentType = res.headers.get( 'content-type' );
		if ( contentType && contentType.includes( 'application/json' ) ) {
			return res.json();
		}
		return Promise.reject( 'Oops, we haven\'t got JSON!' );
	},
	_throwError( err ) {
		throw new Error( err );
	},
};

function calculatePricing() {
	B2BCartAPI.get( EqB2B.restURL() ).then( result => {
		// round the result. Received as a string, so convert first.
		result = Math.ceil( parseFloat( result.replace( ',', '.' ) ) );
		result = result / jQuery( '.quantity input' ).val();
		result = result.toString();
		result = result.replace( '.', ',' );

		jQuery( '#pewc_total_calc_price' ).val( result );

		// get the html for the element that displayes the price on the page
		let priceHTMLToAlter = jQuery( '#pewc-grand-total bdi' ).html();
		// get the position where the span starts, between 0 and that is the price
		const spanIndex = priceHTMLToAlter.indexOf( '<span' );

		priceHTMLToAlter = priceHTMLToAlter.replace( priceHTMLToAlter.substring( 0, spanIndex ), result );

		jQuery( '#pewc-grand-total bdi' ).html( priceHTMLToAlter );
		jQuery( '.pewc-total-field-wrapper .woocommerce-Price-amount:eq(2)' ).addClass( 'showReworkedPricing' );
	} );
}
